<!-- Template for a new page -->
<template>
	<div class="d-flex flex-column flex h100">
		<exemplar class="mb-3" :exemplar="exemplar" />
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import RubricService from "@/services/RubricService";
import Exemplar from "@/components/Exemplar";

import Notie from "@/services/NotieService";

export default {
	name: "ViewExemplar",

	components: {
		Exemplar
	},

	data() {
		return {
			exemplar: {}
		};
	},

	watch: {},

	created() {
		this.loadData();
	},
	methods: {
		loadData() {
			let rid = this.$route.params.rubric_id;
			let tid = this.$route.params.trait_id;
			let sco = this.$route.params.score;
			let eid = this.$route.params.exemplar_id;
			RubricService.getExemplar(rid, tid, sco, eid)
				.then(resp => {
					console.log(resp);
					let exemplar = { response: resp.data };
					this.exemplar = exemplar;

					this.loading = false;
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load exemplar", err);
				})
				.finally(() => {
					this.refreshing = false;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/Scoring/ViewExemplar.vue